import { Helmet } from "react-helmet";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export default function AboutUs() {
  const { t, i18n } = useTranslation();
  const { lang } = useParams();
  const observerRef = useRef(null);

  // ست‌کردن زبان و جهت صفحه (اگر LangLayout داری، می‌تونی این بخش را حذف کنی)
  useEffect(() => {
    if (lang && i18n.changeLanguage) i18n.changeLanguage(lang);
    document.documentElement.lang = lang || "fa";
    document.documentElement.dir = lang === "en" ? "ltr" : "rtl";
  }, [lang, i18n]);

  useEffect(() => {
    const targets = document.querySelectorAll(".fade-in");
    if (!("IntersectionObserver" in window)) {
      targets.forEach((el) => el.classList.add("visible"));
      return;
    }
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    observerRef.current = obs;
    targets.forEach((el) => obs.observe(el));

    return () => {
      try {
        targets.forEach((el) => obs.unobserve(el));
        obs.disconnect();
      } catch {}
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("about.seo.title")}</title>
        <meta name="description" content={t("about.seo.description")} />
        {/* hreflang برای سئو چندزبانه */}
        <link
          rel="alternate"
          hrefLang="fa"
          href={`${window.location.origin}/fa/aboutus`}
        />
        <link
          rel="alternate"
          hrefLang="en"
          href={`${window.location.origin}/en/aboutus`}
        />
      </Helmet>

      <div className="container text-justify">
        <div className="col-xs-12 col-md-12 noPadding parent">
          <div className="col-xs-12 col-md-8 noPadding fade-in from-bottom delay-1">
            <div className="about-header">
              <h1 className="text-blue1 mt-5 mb-2 fs-6 fade-in from-right delay-1">
                {t("about.title")}
              </h1>
              <p className="subtitle fade-in from-right delay-2">
                {t("about.subtitle")}
              </p>
              <p className="fade-in from-right delay-3">
                {t("about.paragraph1")}
              </p>
              <p className="fade-in from-right delay-4">
                {t("about.paragraph2")}
              </p>
            </div>
          </div>

          <div className="col-xs-12 col-md-4 noPadding aramisabout">
            <ul>
              <li>
                <img
                  src="../../assets/aramis.png"
                  alt={t("about.aboutImageAlt")}
                  className="img-responsive fade-in from-bottom delay-1"
                />
              </li>
              {/* این موارد هم از ترجمه خوانده می‌شوند تا دوزبانه باشند */}
              <li className="fade-in from-bottom delay-2">
                {t("about.tags.automation")}
              </li>
              <li className="fade-in from-bottom delay-3">
                {t("about.tags.robotics")}
              </li>
              <li className="fade-in from-bottom delay-4">
                {t("about.tags.ai")}
              </li>
              <li className="fade-in from-bottom delay-5">
                {t("about.tags.ml")}
              </li>
              <li className="fade-in from-bottom delay-6">
                {t("about.tags.innovationSmart")}
              </li>
              <li className="fade-in from-bottom delay-7">
                {t("about.tags.systems")}
              </li>
            </ul>
          </div>
        </div>

        <div className="our-vision col-xs-12">
          <h2 className="text-blue1 mt-4 mb-2 fs-6 fade-in from-right delay-1">
            {t("about.vision.title")}
          </h2>
          <p className="fade-in from-right delay-2">{t("about.vision.body")}</p>
        </div>

        <div className="our-mission col-xs-12">
          <h2 className="text-blue1 mt-4 mb-2 fs-6 fade-in from-right delay-1">
            {t("about.mission.title")}
          </h2>
          <p className="fade-in from-right delay-2">
            {t("about.mission.body")}
          </p>
        </div>

        <div className="our-values mb-5 col-xs-12">
          <h2 className="text-blue1 mt-4 fs-6 fade-in from-right delay-1">
            {t("about.values.title")}
          </h2>
          <ul>
            <li className="fade-in from-bottom delay-1">
              {t("about.values.items.quality")}
            </li>
            <li className="fade-in from-bottom delay-2">
              {t("about.values.items.support")}
            </li>
            <li className="fade-in from-bottom delay-3">
              {t("about.values.items.learning")}
            </li>
            <li className="fade-in from-bottom delay-4">
              {t("about.values.items.social")}
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}
